export const createSortHandler = (cellId, setSort, sortState, order, setOrder) => {
  if (cellId === sortState) {
    setOrder(order === "-" ? "" : "-");
  } else {
    setSort(cellId);
    setOrder("-");
  }
};